export const USERNAME_MIN_LENGTH = 8;
export const PASSWORD_MIN_LENGTH = 6;
export const OTP_VALIDITY_TIME_IN_SECONDS = 180;
